import { APP_VERSION } from '@utils/constants.js'

const KEYS = {
  MODE: 'minha-obra-mode',
  THEME: 'minha-obra-theme',
  FIN_TAB: 'fin_activeTab',
  APP_VERSION: 'minha-obra-app-version',
} as const

export function clearAppLocalState(): void {
  for (const key of Object.values(KEYS)) {
    localStorage.removeItem(key)
  }
}

export function syncAppVersion(): void {
  const stored = localStorage.getItem(KEYS.APP_VERSION)
  if (stored === APP_VERSION) return
  localStorage.setItem(KEYS.APP_VERSION, APP_VERSION)
}

export async function clearServiceWorkerCaches(): Promise<void> {
  if (!('caches' in window)) return
  const names = await caches.keys()
  await Promise.all(names.map((name) => caches.delete(name)))
}

export { KEYS as APP_STORAGE_KEYS }
